export enum ESumType {
    SUM_ALL,
    LEFT_RIGHT
}
